import classNames from 'classnames';

import { Cell } from '../types';

import styles from './conversation.module.scss';

export interface ConversationLinkProps {
  conversationSubjectIndex: number;
  row: Cell[];
  active?: boolean;
}

export const ConversationLink = (props: ConversationLinkProps) => {
  const { conversationSubjectIndex, row, active } = props;
  const conversationSubjectPosition = conversationSubjectIndex / row.length + 1 / row.length / 2;
  const conversationSubjectOnTheLeft = conversationSubjectPosition < 0.5;
  // Curve the link when the linked cell is at the outer edge of a row
  const offCenter = row.length === 2 || (row.length === 3 && conversationSubjectIndex !== 1);
  return (
    <div
      className={classNames(styles.conversationLink, {
        [styles.activeLink]: active,
        [styles.curvedLink]: offCenter,
      })}
      style={{
        left: '50%',
        right: conversationSubjectOnTheLeft
          ? `${conversationSubjectPosition * 100}%`
          : `${100 - conversationSubjectPosition * 100}%`,
        transform: conversationSubjectOnTheLeft ? 'scaleX(-1)' : 'none',
        translate: conversationSubjectOnTheLeft ? '-100% 10px' : '0 10px',
      }}
    />
  );
};
